import React, { createContext, useContext, useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

// Hoist libraries array so its reference stays stable across renders
const LIBRARIES = ['places'];

const MapsContext = createContext({ isLoaded: false, loadError: null, authError: false });

export function MapsProvider({ children }) {
  const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  const [authError, setAuthError] = useState(false);

  // Google Maps fires window.gm_authFailure when the key is invalid or domain not authorized
  useEffect(() => {
    window.gm_authFailure = () => {
      console.warn('[MapsProvider] Google Maps auth failure — domain not authorized or invalid key');
      setAuthError(true);
    };
    return () => { delete window.gm_authFailure; };
  }, []);

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-maps-script',
    googleMapsApiKey: key || '',
    libraries: LIBRARIES,
  });

  return (
    <MapsContext.Provider value={{ isLoaded, loadError, authError }}>
      {children}
    </MapsContext.Provider>
  );
}

export function useMaps() {
  return useContext(MapsContext);
}

export default MapsContext;
